module.exports = __webpack_public_path__ + "static/media/Icn-png.0a95c941.svg";